import React from "react";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";

import CoverLevelComparisonCard, {
  ComparisonCardData,
} from "./cover-level-comparison-card";

type Props = {
  cards: ComparisonCardData[];
  selectedCoverType: string | undefined;
  isMobile: boolean;
  title?: string;
  subtitle?: string;
  editLinkLabel?: string;
  viewLabel?: string;
  selectedLabel?: string;
  orSeparator?: string;
  monthlySuffix?: string;
  onEditDetailsClick: () => void;
  onCardClick: () => void;
};

// Hardcoded fallbacks for when the corresponding CMS fields are not yet
// available (Magnolia rollout transition). Once the dialog publishes the
// fields to all environments and content is authored, the fallbacks become
// dead paths.
const FALLBACK = {
  title: "Cover level",
  subtitle: "Travel Doctor is included with all our cover levels.",
  editLink: "View/Edit cover details",
  viewLabel: "View",
  selectedLabel: "Selected",
  orSeparator: "or",
  monthlySuffix: "a month",
};

function CoverLevelComparisonPanel({
  cards,
  selectedCoverType,
  isMobile,
  title,
  subtitle,
  editLinkLabel,
  viewLabel,
  selectedLabel,
  orSeparator,
  monthlySuffix,
  onEditDetailsClick,
  onCardClick,
}: Readonly<Props>) {
  return (
    <div className="flex flex-col gap-spacing-s pb-spacing-s md:pb-spacing-m">
      <div className="flex flex-row justify-between items-center">
        <p className="font-body-font text-2xs font-[400] leading-[24px] text-text-functional-subtle">
          {title ?? FALLBACK.title}
        </p>
        <LabelButtonWrapper
          label={editLinkLabel ?? FALLBACK.editLink}
          hierarchy="tertiary"
          className="font-body-font leading-[18px] font-[600] text-xs realtive top-[-2px] !px-spacing-xxs"
          onClick={onEditDetailsClick}
        />
      </div>
      <p className="font-body-font text-2xs md:text-[18px] font-[600] leading-[24px] md:leading-custom-size-xxl text-dark-surface-accent-2-primary">
        {subtitle ?? FALLBACK.subtitle}
      </p>
      <div
        className={`grid grid-cols-3 items-stretch ${
          isMobile ? "gap-0 max-md:mx-[-16px]" : "gap-spacing-xs"
        }`}
      >
        {cards.map((card) => {
          return (
            <CoverLevelComparisonCard
              key={card.coverType}
              data={card}
              isSelected={card.coverType === selectedCoverType}
              isMobile={isMobile}
              selectedLabel={selectedLabel ?? FALLBACK.selectedLabel}
              viewLabel={viewLabel ?? FALLBACK.viewLabel}
              orSeparator={orSeparator ?? FALLBACK.orSeparator}
              monthlySuffix={monthlySuffix ?? FALLBACK.monthlySuffix}
              onClick={onCardClick}
            />
          );
        })}
      </div>
    </div>
  );
}

export default CoverLevelComparisonPanel;
